<!-- eslint-disable vue/no-unused-refs -->
<template>
  <div class="facet-drawer-trigger">
    <button
      ref="trigger"
      class="facet-drawer-trigger__button"
      type="button"
      @click.prevent="openFacetDrawer"
    >
      <icon-filter />

      <span v-text="drawerTriggerLabel" />
    </button>
  </div>
</template>

<script>

/**
 * Vue: Facet drawer trigger (facet-drawer-trigger)
 * -----------------------------------------------------------------------------
 * A link that opens the filter drawer.
 *
 */
import { klaviyoEvent } from '~/helpers/klaviyo'
import IconFilter from '~icons/general/filter.svg'

export default {
  name: 'FacetDrawerTrigger',

  components: {
    IconFilter,
  },

  props: {
    resultCount: {
      type: Number,
      default: null,
    },
  },

  computed: {

    /**
     * Compute drawer trigger with / without result count.
     * @returns {String}
     */
    drawerTriggerLabel() {
      if (this.resultCount) {
        return this.$string('collection.filters.drawer.trigger_label_with_result_count', {
          replace: {
            count: this.resultCount,
          },
        })
      }

      return this.$string('collection.filters.drawer.trigger_label')
    },
  },

  methods: {

    /**
     * Opens the facet drawer
     */
    openFacetDrawer() {
      cnvs.EventBus.emit('overlay:open-facet-drawer')
      klaviyoEvent({ label: this.$string('collection.filters.drawer.trigger_label') })
    },
  },
}
</script>

<style lang="scss">
@import './facet-drawer-trigger';
</style>
